export default __webpack_public_path__ + "static/redox-logo-f5b2eb35ca6e884c3683a7e4adba62b3.png";